import React, { Component } from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.css";

import ORKGNav from "./Components/Covid/ORKG_Nav";
import covidData from "./covid19.json";
import TableChart from "./Components/ChartVisualization/tableChart";
import ExampleChartA from "./Components/ChartVisualization/exampleChartA";
import ExampleChartB from "./Components/ChartVisualization/exampleChartB";
import ExampleChartC from "./Components/ChartVisualization/exampleChartC";
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      haveTripleModel: false,
      haveVertexEdgeModel: false,
      haveNodeLinkModel: false,
      hasTabularDataObject: false
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    console.log("want to load the json data");
    console.log(covidData);
    this.parseData(covidData);
  };

  parseData = data => {
    const headersArray = [];
    const valueArray = [];
    const unitsArray = [];

    headersArray.push(data.AnchorHeader);
    unitsArray.push("<<ANCHOR>>");

    const rowIdentifier = data.TabularData;
    rowIdentifier.forEach(identifier => {
      console.log(identifier);
      if (data.hasOwnProperty(identifier)) {
        const rowNode = data[identifier];
        const anchorIdInValueArray = headersArray.indexOf(data.AnchorHeader);
        if (!valueArray[anchorIdInValueArray]) {
          valueArray[anchorIdInValueArray] = [];
        }
        if (rowNode.anchorReferenceId > 0) {
          valueArray[anchorIdInValueArray].push(
            rowNode.anchorLabel + " [" + rowNode.anchorReferenceId + "]"
          );
        } else {
          valueArray[anchorIdInValueArray].push(rowNode.anchorLabel);
        }

        // go through the cellNodes and create headers;
        const cellNodes = rowNode["cellNodes"];
        cellNodes.forEach(cell => {
          const metric = cell["metric"];
          const unit = cell["unit"];
          const value = cell["value"];
          if (headersArray.indexOf(metric) === -1) {
            headersArray.push(metric);
          }
          // headerID;
          const headerIdInvVal = headersArray.indexOf(metric);
          if (!valueArray[headerIdInvVal]) {
            valueArray[headerIdInvVal] = [];
          }

          // add values there;
          valueArray[headerIdInvVal].push(value);
          if (!unitsArray[headerIdInvVal]) {
            unitsArray[headerIdInvVal] = unit;
          }
        });
      }
    });

    // for each rowNode in tabular data

    // reconstruct table;
    // save vars so we can use them in the function;
    this.headerArray = headersArray;
    this.unitArray = unitsArray;
    this.valueArray = valueArray;

    this.tableData = {
      header: this.headerArray,
      units: this.unitArray,
      values: this.valueArray
    };
    this.setState({ hasTabularDataObject: true });
  };

  render() {
    return (
      <>
        <ORKGNav />
        {this.state.hasTabularDataObject && (
          <>
            <TableChart tableData={this.tableData} />
            <ExampleChartA tableData={this.tableData} />
            <ExampleChartB tableData={this.tableData} />
            <ExampleChartC tableData={this.tableData} />
          </>
        )}
      </>
    );
  }
}

export default App;
